import type { MindboxSearchCustomFields, MindboxSearchPayloadParams } from '@/pages/listing/lib/mindbox/shared/types';
import { buildMindboxSearchPayload } from '@/pages/listing/lib/mindbox/shared/buildMindboxSearchPayload';

export type ExcursionMindboxSearchPayloadParams = Omit<MindboxSearchPayloadParams, 'productType'>;

export const buildExcursionMindboxSearchPayload = (
  params: ExcursionMindboxSearchPayloadParams,
): MindboxSearchCustomFields => {
  return buildMindboxSearchPayload({
    ...params,
    productType: 'excursion',
  });
};
